import * as types from "./Login.constants"
import produce from "immer"

const initialState = {
  loading: false,
}

export const loginReducer = (state = initialState, action) =>
  produce(state, draft => {
    // console.warn("loginReducer", state, draft, action)
    switch (action.type) {
      case types.FETCH_LOGIN_PENDING:
        draft.loading = true
        break
      case types.FETCH_LOGIN_SUCCESS:
        draft.loading = false
        break
      case types.FETCH_LOGIN_ERROR:
        draft.loading = false
        break
      default:
        return state
    }
  })
